import { render } from "./MenuHome.vue?vue&type=template&id=bcaba074&scoped=true&ts=true"
import script from "./MenuHome.vue?vue&type=script&lang=ts"
export * from "./MenuHome.vue?vue&type=script&lang=ts"

import "./MenuHome.vue?vue&type=style&index=0&id=bcaba074&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bcaba074"]])

export default __exports__